import styled, { css } from 'styled-components';

export const Container = styled.section`
    ${({ theme }) => css`
        background-color: ${theme.colors.secondary.tints[1].hex};
        padding: 3rem 0;
    `}
`;

export const Heading = styled.h1`
    margin: 0 0 1rem;
`;
